<template>
    <div class="card rounded-16">
        <div class="card-header bg-grey p-2 d-flex align-items-center gap-2 rounded-top">
            <b class="text-16">Discount</b>
        </div>
        <div class="card-body">
            <div class="d-flex align-items-center mb-2">
                <div>
                    <Popper content="This code isn't valid on this order" arrow placement="top" class="w-100 m-0 border-0" :show="discountApplied === false ? true : false">
                        <Field type="text" name="discount" autocomplete="off" class="form-control" placeholder="Enter discount code" v-model="discountCode" :class="{'error': discountApplied === false, 'discount-valid': discountApplied == true}" />
                    </Popper>
                </div>
                <button class="btn btn-primary ms-2" type="button" @click="customApplyDiscount()" :disabled="discountCode == ''">
                    Apply
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Field , ErrorMessage} from 'vee-validate';
    import discount from '@shared/mixins/discount';
    import { navigateWithAttribution } from '@shared/composables/attributionNavigation.js';
    export default {
        components: { Field, ErrorMessage },
        mixins: [discount],
        data() {
            return {
                discountApplied: null
            }
        },
        mounted() {
            console.log(this.discountApplied);
            this.emitter.on('clearDiscountField', data => {
                this.discountApplied = null;
                this.discountCode = '';
            });
        },
        methods: {
            async customApplyDiscount() {
                this.emitter.emit('isLoading', true);

                var formattedCode = this.discountCode.replace('%', '%25');
                    
                const response = await axios.post('/ajax/apply_discount/' + formattedCode);

                this.discountApplied = response.data.discount_applied.discount_applied == true ? true : false;

                if(!response.data.basket || Object.keys(response.data.basket).length < 1) {
                    await navigateWithAttribution('/error');
                }

                this.emitter.emit('isLoading', false);
                this.emitter.emit('refreshBasket');
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>